import {forwardRef, useRef, useState,useEffect, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { generateUuid } from '@/utils/uuid';
import i18n from '@/locales/init'; 
import { AnswerdSvg, AsigndSvg,TranslateSvg } from '../../../Svg';
import {ListeningArticleModuleProxy} from './ListeningArticleModuleProxy';
import style from './index.module.less';
const Article = forwardRef((props: any, ref) => {

  const {pageData, isAI} = props;
  const rootRef = useRef<any>(null);
  const articleRef = useRef<any>();
  const [uuid, _] = useState(() => generateUuid());

  useEffect(() => {
    if (rootRef.current && pageData) {
      articleRef.current = new ListeningArticleModuleProxy();
      articleRef.current.handleInitialArticleModule(rootRef.current);
    }

    const audio = document.getElementById('audio');

    const timeupdateHandle = () => {
      const currentTime = (audio as any).currentTime.toFixed(2);
      articleRef.current._handleUpdateProgreaa({currentTime});
    };
    setClickStatus({sign: false, answer: false, translate: false});
    if (isAI){

    audio!.addEventListener('timeupdate', timeupdateHandle);
    } 
    return () => {
      if (isAI) {
      audio!.removeEventListener('timeupdate', timeupdateHandle);

      }
    };
  }, [rootRef, pageData]);

  const [clickStatus, setClickStatus] = useState<any>({sign: false, answer: false, translate: false});


  const handleClick = (key: string) => {
    const value = clickStatus[key];
    setClickStatus({sign: false, answer: false, translate: false, [key]: !value});
    articleRef.current._handelClick(key, !value);
  };

  useImperativeHandle(ref, () => {
    return {
      root: rootRef.current
    };
  });

  return (
    <>
      <div className={style.articleBox}>
        <div className={style.article}>
          <div id={`l-${uuid}`} className={classNames('l-article-root')} ref={rootRef}></div>
        </div>
        
        <div className={style.controlBox}>
          {/* <span className={style.controlItem} onClick={() => {handleClick('translate');}}>{i18n.t('common.dauyan_location_word')}</span> */}
          <span className={classNames(style.controlItem, clickStatus.sign ? style.active : '')} onClick={() => {handleClick('sign');}}>{AsigndSvg({className: style.icon})}{i18n.t('common.dauyan_signal_words')}</span>
          <span className={classNames(style.controlItem, clickStatus.answer ? style.active : '')} onClick={() => {handleClick('answer');}}>{AnswerdSvg({className: style.icon})}{i18n.t('common.dauyan_answer_words')}</span>
          <span className={classNames(style.controlItem, clickStatus.translate ? style.active : '')} onClick={() => {handleClick('translate');}}>{TranslateSvg({className: style.icon})}{i18n.t('common.dauyan_translate_words')}</span>
        </div>
      </div>
      
    </>
  );
});


export default Article;